import {EndpointsItemsTypes, EndpointItem} from 'interfaces'

/**
 * Transform endpoints search API response to older API response format
 * This transformation is required to make new endpoints search API integration easier.
 * @param endpoints: EndpointItem[]
 * @returns EndpointsItemsTypes[]
 */
export const transformEndpointsListResponse = (
  endpoints: EndpointItem[],
): EndpointsItemsTypes[] => {
  return endpoints.map(endpoint => {
    return {
      adminSetState: endpoint.adminSetState,
      agentUUID: endpoint.agentUUID,
      agentVersion: endpoint.agentVersion,
      binaryType: endpoint.binaryType,
      city: endpoint.cityName,
      countryName: endpoint.countryName,
      cpuFamily: endpoint.cpuFamily,
      debugLevel: Number(endpoint.debugState),
      // 0 means not in debug, 1 means debug request sent to endpoint, 2 means debug request acknowledged by endpoint
      debugMode: Number(endpoint.debugState) > 0,
      deviceName: endpoint.deviceName ?? '',
      disableOption: getDisableOption(endpoint),
      errorMessage: endpoint.errorMessage,
      fallbackMode: endpoint.fallbackMode,
      lastGetConfigTime: endpoint.configurationLastUpdated,
      isTogglePending: getIsTogglePending(endpoint),
      osVersion: endpoint.osVersion,
      policyName: endpoint.policyName,
      realtimeConnection: endpoint.realtimeConnection,
      region: endpoint.region,
      status: endpoint.status,
      updatedOn: endpoint.lastSeen,
      userId: endpoint.emailId ?? endpoint.userId ?? '',
      userUUID: endpoint.userUUID,
      isSelected: false,
    }
  })
}

// check toggle request timestamp is greater than config last updated timestamp
const getIsTogglePending = (endpoint: EndpointItem): boolean => {
  const {adminSetState, disableMode} = endpoint
  const lastGetConfigTime = new Date(endpoint.configurationLastUpdated)
  const lastToggleTime = new Date(endpoint?.adminSetState?.timestamp)
  return (
    adminSetState?.enabled === disableMode && lastToggleTime > lastGetConfigTime
  )
}
// send toggle state if admin has toggled the endpoint else current disable option
const getDisableOption = (endpoint: EndpointItem): boolean => {
  if (getIsTogglePending(endpoint)) {
    return !endpoint.adminSetState?.enabled
  } else {
    return endpoint.disableMode
  }
}
